import { Link, useNavigate } from "react-router-dom";

import { useAuth } from "~/contexts/AuthProvider";
import { useTeams } from "~/hooks/useTeams";
import styles from "~/pages/login/Login.module.scss";
import { routes } from "~/router";

/**
 * The ways out of a required onboarding step: it hides the app until the
 * team completes it, but the user's other teams aren't held back by it.
 */
const OnboardingStepExits = () => {
  const { clearAuth } = useAuth();
  const navigate = useNavigate();
  const { data: teams = [] } = useTeams();

  const onSignOut = () => {
    clearAuth();
    navigate(routes.auth.login(), { replace: true });
  };

  return (
    <>
      {teams.length > 1 && (
        <div className={styles.footer}>
          <div className={styles.footerText}>Working on another team?</div>
          <Link to={routes.selectTeam()} className={styles.footerLink}>
            Switch team
          </Link>
        </div>
      )}
      <div className={styles.footer}>
        <div className={styles.footerText}>Not your account?</div>
        <button type="button" onClick={onSignOut} className={styles.footerLink}>
          Sign out
        </button>
      </div>
    </>
  );
};

export default OnboardingStepExits;
